import { useAuthInfo } from '@propelauth/react';
import { type ReactNode, useCallback, useMemo, useState } from 'react';

import { ActionsContext, type AdminAgentOpenOptions, type AdminAgentScope, PanelContext } from './admin-agent-contexts';

export function AdminAgentProvider({ children }: { children: ReactNode }) {
  const { user } = useAuthInfo();
  const eligible = Boolean(user?.email?.trim());

  const [open, setOpen] = useState(false);
  const [scope, setScope] = useState<AdminAgentScope>('portfolio');
  const [organizationId, setOrganizationId] = useState<string | undefined>();
  const [organizationName, setOrganizationName] = useState<string | undefined>();

  const openDrawer = useCallback(() => {
    setOpen(true);
  }, []);

  const openPortfolio = useCallback((options?: AdminAgentOpenOptions) => {
    setScope('portfolio');
    setOrganizationId(undefined);
    setOrganizationName(undefined);
    if (options?.open !== false) {
      setOpen(true);
    }
  }, []);

  const openOrganization = useCallback((clientId: string, clientName: string, options?: AdminAgentOpenOptions) => {
    setScope('organization');
    setOrganizationId(clientId);
    setOrganizationName(clientName);
    if (options?.open !== false) {
      setOpen(true);
    }
  }, []);

  const actions = useMemo(
    () => ({ eligible, openDrawer, openPortfolio, openOrganization }),
    [eligible, openDrawer, openPortfolio, openOrganization]
  );

  const panel = useMemo(
    () => ({ open, setOpen, scope, organizationId, organizationName }),
    [open, setOpen, scope, organizationId, organizationName]
  );

  return (
    <ActionsContext.Provider value={actions}>
      <PanelContext.Provider value={panel}>{children}</PanelContext.Provider>
    </ActionsContext.Provider>
  );
}
